module.exports = __webpack_public_path__ + "img/hexa_blue_2.4ca3be86.png";